import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class AudioHigher extends Icon {
  render() {
    let { color, size, style, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        style={style}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
      >
        <g fill={color}>
          <path d="M9.4,8c0,0.7-0.3,1.2-0.7,1.6l0.6,1.1c0.8-0.6,1.4-1.5,1.4-2.6s-0.5-2.1-1.4-2.6L8.7,6.4 C9.1,6.8,9.4,7.3,9.4,8z" />
          <path d="M11.6,1.3L11,2.4c1.8,1.2,3,3.2,3,5.6c0,2.4-1.2,4.5-3,5.6l0.6,1.1c2.1-1.4,3.6-3.9,3.6-6.7 C15.2,5.2,13.8,2.7,11.6,1.3z" />
          <path d="M13,8c0-2-1-3.7-2.5-4.7L9.9,4.4C11,5.2,11.7,6.5,11.7,8s-0.8,2.8-1.9,3.6l0.6,1.1C12,11.7,13,10,13,8z" />
          <path d="M5.5,13.7l-4.3-3.6L1,9.5v-3l0.3-0.6l4.3-3.6l1.2,0.6v10.2L5.5,13.7z M2.5,9.1l2.8,2.4v-7L2.5,6.9V9.1z" />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/AudioHigher.js